import { render, staticRenderFns } from "./by_card.vue?vue&type=template&id=5f3016ba&"
import script from "./by_card.vue?vue&type=script&lang=js&"
export * from "./by_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports